<div class="modal-header">
    <h6 class="modal-title medium">{{'updateSupervisorProgram' | translate }}</h6>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="w-100 float-left">
    <div class="w-100 float-left p-4 modal-body">
        <h6 class="mb-3"> {{'selectProgram' | translate }} </h6>
        <div class="w-100 float-left">
            <div class="light-bg w-100 float-left p-2 grid-details">
                <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center">
                    <div class="checkbox checkbox-primary">
                        <input id="self" type="checkbox" [(ngModel)]="selectedAll" (change)="selectAll($event)">
                        <label for="self" class="mb-0"></label>
                    </div>
                </div>
                <div class="col-lg-11 col-md-11 col-sm-11 col-xs-11 float-left">
                    <h6 class="mb-lg-0 medium"> {{'selectAll' | translate }} </h6>
                </div>
            </div>
        </div>
        <div class="w-100 float-left">
            <div class="light-bg w-100 float-left p-2 grid-details"
                 *ngFor='let input of programData.scorecardData;index as i'>
                <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center">
                    <div class="checkbox checkbox-primary">
                        <input id="id_{{input.scorecardId}}" type="checkbox" [(ngModel)]="input.selected"
                               (change)="checkIfAllSelected(input,$event)">
                        <label for="id_{{input.scorecardId}}" class="mb-0"></label>
                    </div>
                </div>
                <div class="col-lg-11 col-md-11 col-sm-11 col-xs-11 float-left">
                    <h6 class="mb-lg-0 medium"> {{input.programName}} </h6>
                </div>
            </div>
        </div>
        <div class="w-100 float-left p-4 modal-body">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 float-left">
                <div class="form-group w-100 float-left">
                    <label> {{'reason' | translate}} </label>
                    <input type="textarea" class="form-control" [(ngModel)]="comments">
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button class="btn btn-primary float-right" (click)="changeApprover()"> {{'save' | translate }}</button>
    </div>
</div>



// WEBPACK FOOTER //
// ./src/app/employee/addSupervisor.html